const RankPopup = ({ isOpen, onClose, currentRank, currentCount }) => {
  const ranks = [
    { 
      min: 0, 
      max: 99, 
      title: 'มือใหม่หัดสร้าง', 
      icon: '🌱', 
      description: 'เริ่มต้นการเดินทางสู่การเป็นนักสร้าง Prompt' 
    },
    { 
      min: 100, 
      max: 999, 
      title: 'นักสร้างมือทอง', 
      icon: '🏅', 
      description: 'ผู้มีประสบการณ์ในการสร้าง Prompt' 
    },
    { 
      min: 1000, 
      max: 4999, 
      title: 'ปรมาจารย์ Prompt', 
      icon: '🎯', 
      description: 'ผู้เชี่ยวชาญการสร้าง Prompt ระดับสูง' 
    },
    { 
      min: 5000, 
      max: 9999, 
      title: 'เทพแห่ง AI', 
      icon: '⚡', 
      description: 'ผู้ชำนาญพิเศษในการสร้าง Prompt' 
    },
    { 
      min: 10000, 
      max: 99999, 
      title: 'ตำนานนักสร้าง', 
      icon: '👑', 
      description: 'ตำนานผู้สร้าง Prompt อันยิ่งใหญ่' 
    },
    { 
      min: 100000, 
      max: Infinity, 
      title: 'จักรพรรดิ AI', 
      icon: '🔮', 
      description: 'ผู้ครองบัลลังก์แห่งการสร้าง Prompt' 
    }
  ];

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div className="bg-gray-900 rounded-xl p-6 max-w-md w-full mx-4 border border-gray-700">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-bold text-white">ระดับยศ</h2>
          <button 
            onClick={onClose}
            className="text-gray-400 hover:text-gray-300"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        <div className="space-y-4">
          {ranks.map((rank) => (
            <div 
              key={rank.title}
              className={`p-3 rounded-lg ${
                currentRank === rank.title 
                  ? 'bg-purple-500/20 border border-purple-500/50' 
                  : 'bg-gray-800/50'
              }`}
            >
              <div className="flex items-center gap-3">
                <span className="text-2xl">{rank.icon}</span>
                <div>
                  <h3 className="font-semibold text-white">
                    {rank.title}
                    {currentRank === rank.title && (
                      <span className="ml-2 text-sm text-purple-400">(ยศปัจจุบัน)</span>
                    )}
                  </h3>
                  <p className="text-sm text-gray-400">{rank.description}</p>
                  <p className="text-xs text-gray-500 mt-1">
                    ต้องสร้าง Prompt: {rank.min} - {rank.max === Infinity ? '∞' : rank.max}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-6 p-4 bg-gray-800/50 rounded-lg">
          <p className="text-sm text-center text-gray-400">
            คุณได้สร้าง Prompt ไปแล้ว{' '}
            <span className="text-purple-400 font-semibold">{currentCount}</span> Prompt
          </p>
        </div>
      </div>
    </div>
  );
};

export default RankPopup; 